import React from "react";
import { Edit } from "@mui/icons-material";
import { editCustomerEffect } from "../../../../stores/CustomersStore/CustomersStore.effects";
import { Colors } from "../../../../constants/Colors";
import { Customer } from "../../../../types/customers.types";
import CustomerFormModal from "../CustomerFormModal/CustomerFormModal";

interface Props {
  customer: Customer;
}

const EditCustomer: React.FC<Props> = ({ customer }) => {
  return (
    <CustomerFormModal
      customer={customer}
      effect={editCustomerEffect}
      isEdit
      title="Editar cliente"
      confirmText="Confirmar"
      cancelText="Cancelar"
      TriggerComponent={
        <Edit
          sx={{
            color: Colors.primary[100],
            ":hover": { opacity: "70%" },
            cursor: "pointer",
          }}
        />
      }
    />
  );
};

export default EditCustomer;
